import { MerchProductFront } from "@services/merch/types/api/merch-product-front";
import { PHONE_NAMES } from "../constants/phone-names";

export const getProductImageSrc = (product: MerchProductFront): string => {
  const whiteProduct = product.colors.find(
    (item) => item.name?.toLowerCase() === "white"
  );
  const defaultColorImage = product.colors.find(
    (color) => color?.images?.[0]?.src
  )?.images?.[0].src;
  const defaultSizeImage = product.sizes.find((size) => size?.images?.[0]?.src)
    ?.images?.[0].src;

  if (whiteProduct) {
    return whiteProduct.image || whiteProduct.images?.[0].src || product.image;
  } else if (defaultColorImage) {
    return defaultColorImage || product.image;
  } else if (defaultSizeImage) {
    return defaultSizeImage || product.image;
  } else if (product.sizes) {
    const sizeProduct = product.sizes.find((size) =>
      PHONE_NAMES.includes(size.name)
    );
    return sizeProduct?.images?.[0]?.src || product.image;
  }

  return product.image;
};
